var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.css.wrapperClass },
    [
      _c(
        "a",
        {
          class: [
            "btn-nav",
            _vm.css.linkClass,
            _vm.isOnFirstPage ? _vm.css.disabledClass : "",
          ],
          on: {
            click: function ($event) {
              return _vm.loadPage(1)
            },
          },
        },
        [
          _vm.css.icons.first != ""
            ? _c("i", { class: [_vm.css.icons.first] })
            : _c("span", [_vm._v("«")]),
        ]
      ),
      _c(
        "a",
        {
          class: [
            "btn-nav",
            _vm.css.linkClass,
            _vm.isOnFirstPage ? _vm.css.disabledClass : "",
          ],
          on: {
            click: function ($event) {
              return _vm.loadPage("prev")
            },
          },
        },
        [
          _vm.css.icons.next != ""
            ? _c("i", { class: [_vm.css.icons.prev] })
            : _c("span", [_vm._v(" ‹")]),
        ]
      ),
      _vm.notEnoughPages
        ? [
            _vm._l(_vm.totalPage, function (n) {
              return [
                _c("a", {
                  class: [
                    _vm.css.pageClass,
                    _vm.isCurrentPage(n) ? _vm.css.activeClass : "",
                  ],
                  domProps: { innerHTML: _vm._s(n) },
                  on: {
                    click: function ($event) {
                      return _vm.loadPage(n)
                    },
                  },
                }),
              ]
            }),
          ]
        : [
            _vm._l(_vm.windowSize, function (n) {
              return [
                _c("a", {
                  class: [
                    _vm.css.pageClass,
                    _vm.isCurrentPage(_vm.windowStart + n - 1)
                      ? _vm.css.activeClass
                      : "",
                  ],
                  domProps: { innerHTML: _vm._s(_vm.windowStart + n - 1) },
                  on: {
                    click: function ($event) {
                      return _vm.loadPage(_vm.windowStart + n - 1)
                    },
                  },
                }),
              ]
            }),
          ],
      _c(
        "a",
        {
          class: [
            "btn-nav",
            _vm.css.linkClass,
            _vm.isOnLastPage ? _vm.css.disabledClass : "",
          ],
          on: {
            click: function ($event) {
              return _vm.loadPage("next")
            },
          },
        },
        [
          _vm.css.icons.next != ""
            ? _c("i", { class: [_vm.css.icons.next] })
            : _c("span", [_vm._v("› ")]),
        ]
      ),
      _c(
        "a",
        {
          class: [
            "btn-nav",
            _vm.css.linkClass,
            _vm.isOnLastPage ? _vm.css.disabledClass : "",
          ],
          on: {
            click: function ($event) {
              return _vm.loadPage(_vm.totalPage)
            },
          },
        },
        [
          _vm.css.icons.last != ""
            ? _c("i", { class: [_vm.css.icons.last] })
            : _c("span", [_vm._v("»")]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }